export const INDIA_TIME_ZONE = "Asia/Kolkata";
export const INDIA_UTC_OFFSET_MINUTES = 330;
export const INDIA_UTC_OFFSET_MS = INDIA_UTC_OFFSET_MINUTES * 60000;

export const getIndiaDateParts = (date = new Date()) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return null;
    const indiaValue = new Date(value.getTime() + INDIA_UTC_OFFSET_MS);
    return {
        year: indiaValue.getUTCFullYear(),
        month: indiaValue.getUTCMonth() + 1,
        day: indiaValue.getUTCDate(),
        hour: indiaValue.getUTCHours(),
        minute: indiaValue.getUTCMinutes(),
        second: indiaValue.getUTCSeconds(),
        millisecond: indiaValue.getUTCMilliseconds(),
    };
};

export const createIndiaDateTimeIso = (dateKey, hour = 0, minute = 0, second = 0, millisecond = 0) => {
    const [year, month, day] = String(dateKey || "").slice(0, 10).split("-").map(Number);
    if (!year || !month || !day) return null;
    const utcMs = Date.UTC(year, month - 1, day, hour, minute, second, millisecond) - INDIA_UTC_OFFSET_MS;
    return new Date(utcMs).toISOString();
};

export const getIndiaEndOfDateMs = (dateKey) => {
    const iso = createIndiaDateTimeIso(dateKey, 23, 59, 59, 999);
    return iso ? new Date(iso).getTime() : NaN;
};

export const getIndiaDateKey = (time = new Date()) => {
    const parts = getIndiaDateParts(time);
    if (!parts) return "";
    return `${parts.year}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}`;
};

export const formatIndiaTime = (time, fallback = "-") => {
    if (!time) return fallback;
    const value = new Date(time);
    if (Number.isNaN(value.getTime())) return fallback;
    return value.toLocaleTimeString("en-IN", {
        timeZone: INDIA_TIME_ZONE,
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    }).toUpperCase();
};

export const getIndiaTimeInputValue = (time) => {
    if (!time) return "";
    const parts = getIndiaDateParts(time);
    if (!parts) return "";
    return `${String(parts.hour).padStart(2, "0")}:${String(parts.minute).padStart(2, "0")}`;
};
